import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { AddApiRapidValueService } from '@app/modules/vault/components/add-document/add-api-rapid-value.service';
import { USStates } from '@app/shared/utils/enum';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@AutoUnsubscribe()
@Component({
  selector: 'template-basic-form',
  templateUrl: './template-basic-form.component.html',
  styleUrls: ['./template-basic-form.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],

  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TemplateBasicFormComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() Form1 = [];
  @Input() documentForm;
  @Input() hide_description_Section = false;
  @Input() askSecurityQuestion = false;
  arrayItems;
  isEnableForm = false;
  beneFicaryForm = [];
  buttonDisplayText = '';
  receivedPropertyData;
  showCopyDataButton = false;
  subscription: Subscription = new Subscription();
  afterViewInit = false;
  constructor(
    private cd: ChangeDetectorRef,
    private toastr: ToastrService,
    private addApiRapidValueService: AddApiRapidValueService,
    private formBuilder: UntypedFormBuilder
  ) {}
  // convenience getters for easy access to form fields
  get f() {
    return this.documentForm.controls;
  }
  get t() {
    return this.f.dynamicFieldsForm as UntypedFormArray;
  }

  templateList(empIndex: number, formControlName): UntypedFormArray {
    return this.documentForm.controls.beneFicaryForm['controls'][empIndex]['controls'][formControlName];
  }
  removeBeneficary(formcontrolName, index, childIndex) {
    const items = this.documentForm.controls['beneFicaryForm']['controls'][index]['controls'][formcontrolName] as UntypedFormArray;
    items.removeAt(childIndex);
    this.cd.detectChanges();
  }
  addBeneficiarybyform(formcontrolName, index) {
    const element = this.Form1[0]['multiFieldForm'][index];
    const test = new UntypedFormGroup({});
    element.template.forEach((childelement) => {
      if (childelement['type'] == 'email') {
        if (childelement['isRequired']) {
          test.addControl(childelement.formControlName, new UntypedFormControl('', [Validators.required, Validators.email]));
        } else {
          test.addControl(childelement.formControlName, new UntypedFormControl('', [Validators.email]));
        }
      } else {
        if (childelement['isRequired']) {
          test.addControl(childelement.formControlName, new UntypedFormControl('', Validators.required));
        } else {
          test.addControl(childelement.formControlName, new UntypedFormControl(''));
        }
      }
    });
    const items = this.documentForm.controls['beneFicaryForm']['controls'][index]['controls'][formcontrolName] as UntypedFormArray;
    items.push(test);
    this.cd.detectChanges();
  }

  toggleActive(event: any) {
    event.preventDefault();
    this.isEnableForm = !this.isEnableForm;
  }

  clickNt(index) {
    try {
      let newArrayItemList = [];
      this.arrayItems.forEach((element, currentIndex) => {
        let objCopy = { ...element };
        if (currentIndex == index) {
          objCopy.setDefaultEyeField = !objCopy.setDefaultEyeField;
        }
        newArrayItemList.push(objCopy);
      });
      this.arrayItems = newArrayItemList;
      this.cd.detectChanges();
    } catch (error) {
      console.error('**', error);
    }
  }
  childMethod() {
    this.ngOnInit();
  }
  ngOnInit(): void {
    let dynamicFieldsFormValue = this.documentForm.value.dynamicFieldsForm[0];
    this.documentForm.setControl('dynamicFieldsForm', new UntypedFormArray([]));
    this.arrayItems = this.Form1[0]['singleFieldForm'];
    this.t.clear();
    const test = this.formBuilder.group({});
    this.arrayItems.forEach(function (value) {
      if (value['type'] === 'Section') {
      } else if (value['type'] == 'email') {
        test.addControl(value.formControlName, new UntypedFormControl(''));
      } else {
        test.addControl(value.formControlName, new UntypedFormControl(''));
      }
    });
    this.documentForm.removeControl('beneFicaryForm');
    this.documentForm.addControl('beneFicaryForm', new UntypedFormArray([]));
    if (this.Form1[0]['multiFieldForm'].length) {
      this.beneFicaryForm = [];
      this.beneFicaryForm = this.Form1[0]['multiFieldForm'];
      this.Form1[0]['multiFieldForm'].forEach((element) => {
        const temporary = new UntypedFormGroup({});
        temporary.addControl(element.formControlName, new UntypedFormArray([]));
        const test = new UntypedFormGroup({});
        const items = this.documentForm.controls['beneFicaryForm'] as UntypedFormArray;
        items.push(temporary);
      });
      for (let i = 0; i < this.Form1[0]['multiFieldForm'].length; i++) {}
    } else {
      this.beneFicaryForm = [];
    }
    this.t.push(test);
    try {
      this.documentForm.controls.dynamicFieldsForm.controls[0].setValue(dynamicFieldsFormValue);
      this.addApiRapidValueService.setPropertyDataFromGeneral(dynamicFieldsFormValue);
    } catch (error) {}

    this.subscription.add(
      this.addApiRapidValueService.getPropertyDataFromLiveFeeds().subscribe((data) => {
        this.receivedPropertyData = data;
        const propertyDataExist =
          data && Object.keys(data).length > 0 && Object.values(data).some((value) => value !== null && value !== undefined && value !== '');
        if (propertyDataExist) {
          if (data.type == 'vehicleDatabase') {
            this.buttonDisplayText = 'Vehicle Database';
          } else if (data.type == 'zillow') {
            this.buttonDisplayText = 'Zillow';
          }
          this.showCopyDataButton = true;
        } else {
          this.showCopyDataButton = false;
        }
      })
    );

    this.subscription.add(
      this.documentForm.valueChanges.pipe(debounceTime(300), distinctUntilChanged()).subscribe((data) => {
        Object.keys(this.documentForm.controls).forEach((field) => {
          const control = this.documentForm.get(field);
          if (control.dirty) {
            this.addApiRapidValueService.setPropertyDataFromGeneral(data.dynamicFieldsForm[0]);
          }
        });
      })
    );
    this.cd.detectChanges();
  }

  ngAfterViewInit(): void {
    this.afterViewInit = true;
  }
  copyDataFromLiveFeeds() {
    if (this.receivedPropertyData) {
      const data = this.receivedPropertyData;
      switch (data.type) {
        case 'zillow':
          try {
            const stateName = USStates[data.setting.state as keyof typeof USStates] || '';
            const zillowFieldsControl = this.documentForm.controls.dynamicFieldsForm['controls'][0];
            let isLotSizeAssigned = false;
            const zillowPatchData: any = {};
            const zillowValueMapping = new Map<string, any>([
              ['streetaddress', data.setting?.StreetAddress],
              ['city', data.setting?.city],
              ['country', 'United States of America'],
              ['state', stateName],
              ['zipcode', data.setting?.zipCode],
              ['bedrooms', data.response?.bedrooms],
              ['bathrooms', data.response?.bathrooms],
              ['yearbuilt', data.response?.yearBuilt],
            ]);

            Object.keys(zillowFieldsControl.controls).forEach((controlName) => {
              const control = zillowFieldsControl.controls[controlName];
              const formControlName = controlName.toLowerCase();
              for (const [key, value] of zillowValueMapping) {
                if (formControlName.includes(key)) {
                  zillowPatchData[controlName] = value;
                  break;
                }
              }

              if (formControlName.includes('lotsize')) {
                zillowPatchData[controlName] = data.response?.lotSize;
                isLotSizeAssigned = true;
              } else if (formControlName.includes('squarefootage')) {
                zillowPatchData[controlName] = !isLotSizeAssigned ? data.response?.livingArea : '';
              }
            });
            zillowFieldsControl.patchValue(zillowPatchData);
            Object.keys(zillowPatchData).forEach((controlName) => {
              zillowFieldsControl.controls[controlName].markAsDirty();
            });
            this.toastr.success(`Data from Zillow was successfully copied to general information`);
          } catch (error) {
            this.toastr.error('Error copying Zillow data');
          }
          break;
        case 'vehicleDatabase':
          try {
            const makeYear = data.setting.year.toString();
            const vehicleFieldsControl = this.documentForm.controls.dynamicFieldsForm['controls'][0];
            const vehiclePatchData: any = {};
            const vehicleValueMapping = new Map<string, any>([
              ['make', data.setting.make],
              ['model', data.setting.model],
              ['year', makeYear ?? ''],
              ['trim', data.setting.trim],
            ]);

            Object.keys(vehicleFieldsControl.controls).forEach((controlName) => {
              const control = vehicleFieldsControl.controls[controlName];
              const formControlName = controlName.toLowerCase();
              for (const [key, value] of vehicleValueMapping) {
                if (formControlName.includes(key)) {
                  vehiclePatchData[controlName] = value;
                  break;
                }
              }
            });
            vehicleFieldsControl.patchValue(vehiclePatchData);
            Object.keys(vehiclePatchData).forEach((controlName) => {
              vehicleFieldsControl.controls[controlName].markAsDirty();
            });
            this.toastr.success(`Data from Vehicle Database was successfully copied to general information`);
          } catch (error) {
            this.toastr.error('Error copying vehicle data');
          }
          break;
        default:
        // this.toastr.warning(`No ${data.type} data to copy `);
      }
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
  handleDateChange(value, formcontrol) {
    // (this.documentForm.controls['dynamicFieldsForm'] as any).controls[0].controls[formcontrol].setValue(value != 'Invalid date' ? value : '');
  }
  handleDateChange2(value, formcontrol) {
    (this.documentForm.controls['dynamicFieldsForm'] as any).controls[0].controls[formcontrol].setValue(value != 'Invalid date' ? value : '');
  }
}
